module.exports = __webpack_public_path__ + "static/media/kudos-share.6a674aeb.svg";